module.exports = __webpack_public_path__ + "static/media/group2.065f89e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group2.svg
// module id = 1355
// module chunks = 0